module.exports = __webpack_public_path__ + "static/media/iconapproved.25e173b3.svg";